module.exports = __webpack_public_path__ + "static/media/instagram.9edd5e4b.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Container/components/Footer/img/instagram.png
// module id = 147
// module chunks = 0